import * as Common from '@tfo/common'
import * as React from 'react'
import { observer } from 'mobx-react'
import ReportsItemDate from './ReportsItemDate'
import { WrappedComponentProps, injectIntl } from 'react-intl'
import '../ReportsItem.scss'
import { useState } from 'react'
import ReportsItemIndividualDialog from './ReportsItemIndividualDialog'
import { IOrderClient } from '@tfo/common/src/models'
import { displayNationalId } from '../../../../../../../utils/NationalId'
export interface ReportsItemWaitingApprovalProps {
	data: Common.models.IOrderClient
	reportPackages: Common.models.ReportPackage[]
	showCompanyName: boolean
	updateOrder: (order: IOrderClient) => void
	removeOrder: (order: IOrderClient) => void
}

const ReportsItemWaitingApproval = ({ data, intl, reportPackages, showCompanyName, updateOrder, removeOrder }: ReportsItemWaitingApprovalProps & WrappedComponentProps) => {
	const [individualModal, setIndividualModal] = useState<boolean>(false)

	const toggleIndividualModal = (): void => {
		setIndividualModal(!individualModal)
	}

	return (<>
		<div
			className={'ReportsItem ReportsItem--standard ReportsItem--active'}
			id={'reportsItem_' + data.id.toString()}
			onClick={() => toggleIndividualModal()}
		>
			<div className={'ReportsItem__Inner'}>
				{showCompanyName && (
					<div className={'ReportsItem__Cell'}>{data.companyName}</div>
				)}
				<div className={'ReportsItem__Cell'}>
					{reportPackages.find(x => x.id === data.servicePackageId)
						?.customName ?? ''}
				</div>
				<div className={'ReportsItem__Cell ReportsItem__Cell--centerAlign'}>
					{data.candidate?.firstName}
				</div>
				<div className={'ReportsItem__Cell ReportsItem__Cell--centerAlign'}>
					{data.candidate?.lastName}
				</div>
				<div
					className={
						'ReportsItem__Cell ReportsItem__Cell--centerAlign'
					}>{displayNationalId(data.candidate)}
				</div>
				<ReportsItemDate
					date={data.created}
					label={intl.formatMessage({ id: 'common.ordered' })}
				/>
			</div>
		</div>
		{data?.candidate &&
			<ReportsItemIndividualDialog open={individualModal} selectedOrder={data} onClose={toggleIndividualModal} updateOrder={updateOrder} removeOrder={removeOrder} />
		}
	</>
	)
}
export default injectIntl(observer(ReportsItemWaitingApproval))
